import React from 'react';
import { useTranslation } from 'react-i18next';

import './PublicStep.styles.scss';

const PublicStep: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="public-step">
      <ul>
        <li>{t('publicStepLi1')}</li>
        <li>{t('publicStepLi2')}</li>
        <li>{t('publicStepLi3')}</li>
      </ul>
    </div>
  );
};

export default PublicStep;
